import { isPlatformBrowser } from "@angular/common";
import { Component, Inject, OnInit, PLATFORM_ID, DOCUMENT } from '@angular/core';
import { Observable } from "rxjs";
import { CustomStoreFinderService } from "../../../../spartacus/custom/core/storefinder/facade/store-finder.service";
import { ICON_TYPE } from "../../../icons/icon.model";

@Component({
  selector: 'app-custom-our-stores',
  templateUrl: './custom-our-stores.component.html',
  standalone: false
})
export class CustomOurStoresComponent implements OnInit {
  locations$: any;
  isLoading$: Observable<boolean>;
  selectedStoreIndex: number;
  iconTypes = ICON_TYPE;

  constructor(
    private storeFinderService: CustomStoreFinderService,
    @Inject(DOCUMENT) private document: any,
    @Inject(PLATFORM_ID) private platformId: any
  ) { }

  ngOnInit(): void {
    this.isLoading$ = this.storeFinderService.getStoresLoading();
    this.locations$ = this.storeFinderService.getFindStoresEntities();
    this.storeFinderService.callFindStoresAction();
  }

  selectStoreItemList(index: number): void {
    this.selectedStoreIndex = index;
    const storeListItem = this.document.getElementById('item-' + index);
    storeListItem.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
    storeListItem.classList.add('selected');
    storeListItem.classList.add('marked');
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(function () {
        storeListItem.classList.remove('selected');
        storeListItem.classList.remove('marked');
      }, 1500);
    }
  }
}
